import React from 'react';

const DividerWithText = ({ title, spacing='', children, withLine=true}) => {
    return (
        <div className={`divider-with-text ${spacing}`}>
            <span>{title}</span>
                {children}
            { withLine && <div className='divider-common'/> }
        </div>
    );
};

export default DividerWithText;
